import raw from '../../../../packages/shared/brand/wordmark.svg?raw'
import styles from './Wordmark.module.css'

/**
 * The wordmark "fjalim.": the one file in packages/shared/brand/wordmark.svg, which the site inlines too.
 * Ink follows the text colour, so it reads on paper and on the dark theme; the full stop keeps the brand red.
 */
const svg = raw
  .replace(/<title[^>]*>.*?<\/title>/s, '')
  .replace(' role="img" aria-labelledby="t"', ' aria-hidden="true" focusable="false"')
  .replaceAll('#17130F', 'currentColor')
  .replaceAll('#C8102E', 'var(--red)')

export function Wordmark({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  return <span className={`${styles.wordmark} ${styles[size]}`} dangerouslySetInnerHTML={{ __html: svg }} />
}
